import { KeycloakProfile } from '../redux/reducers/auth'

const EXPORT_ROLES = ['CEO', 'PORTF MANAGER', 'ASSISTANT']
// CEO má dvě teritoriální varianty - Apex "CEO", Imperium "CEO IF"
const CEO_ROLES = ['CEO', 'CEO IF']

const hasAnyRole = (user: KeycloakProfile, roles: string[]) => {
  if (!user || !user.roles) {
    return false
  }
  return user.roles.some(role => roles.includes(role))
}

/** Export seznamu klientů (šifrovaný XLSX). */
export const canExportClients = (user: KeycloakProfile) => hasAnyRole(user, EXPORT_ROLES)

/**
 * Export detailu klienta. Soubor se NEšifruje, takže je jen pro CEO -
 * stejná podmínka je vynucená i na backendu.
 */
export const canExportClientDetail = (user: KeycloakProfile) => hasAnyRole(user, CEO_ROLES)
